<template>
  <el-tag style="height: auto" :type="getTagType">
    {{ $t('common_words.code') }}: {{ worker.code || '-' }} <br />
    {{ $t('common_words.name') }}: {{ worker.name || '-' }}
  </el-tag>
</template>

<script>
export default {
  name: 'crew-workers-tag',
  props: {
    worker: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getTagType() {
      return this.worker.deleted_at ? 'danger' : 'info';
    },
  },
};
</script>
